import { useEffect, useState } from "react";

export default function AnimatedCounter({ value, duration = 800, className = "" }) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    const start = 0;
    const end = Number(value) || 0;
    if (end === start) { setDisplay(end); return; }
    const step = (end - start) / (duration / 16);
    let cur = start;
    const t = setInterval(() => {
      cur += step;
      if ((step > 0 && cur >= end) || (step < 0 && cur <= end)) {
        setDisplay(end); clearInterval(t);
      } else {
        setDisplay(Math.round(cur));
      }
    }, 16);
    return () => clearInterval(t);
  }, [value, duration]);
  return <span className={className}>{display}</span>;
}
